import { contactParams } from '../../../presentation/pages/contact/ContactPageViewModel'
import { httpDelete, httpDeleteWithPayload, httpGet, httpPost, httpPut } from '../../data'
import type { IContact, IContactDeleted, IContactList } from '../../../domain/interfaces/IContact'

export async function getContacts(queryString: string) {
  return await httpGet<IContactList>(`/contacts?${queryString}`, false)
}

export async function getContactById(id: string) {
  return await httpGet<IContact>(`/contacts/${id}`, true)
}

export async function createContact(contact: contactParams, contractorId: string) {
  return await httpPost<IContact>(
    '/contacts',
    { ...contact, contractorId },
    undefined, //no additional headers
    true,
  )
}

export async function editContact(contact: contactParams, contactId: string) {
  return await httpPut<IContact>(
    `/contacts/${contactId}`,
    contact,
    false, // direct data parsing is false
  )
}

export async function deleteContact(contactId: string) {
  return await httpDelete<IContact>(
    `/contacts/${contactId}`,
    undefined, //no additional headers
  )
}

export async function searchContacts(skip: number, limit?: number, key?: string) {
  const urlStr = `/contacts?searchKey=${key}&skip=${skip}&limit=${limit ?? 8}`
  return await httpGet<IContactList>(urlStr, false)
}

// TODO: Add when BE updated
export async function deleteContacts(contactIds: string[]) {
  return await httpDeleteWithPayload<IContactDeleted[]>('/contacts/bulk', { contactIds })
}
